export default {
  /* alert */
  ALERT_SHOW: 'ALERT_SHOW',
  ALERT_HIDE: 'ALERT_HIDE',

  /* global */
  ROLES_GET_REQUEST: 'ROLES_GET_REQUEST',
  ROLES_GET_SUCCESS: 'ROLES_GET_SUCCESS',
  ROLES_GET_ERROR: 'ROLES_GET_ERROR',
  OWNERSHIP_TYPES_GET_REQUEST: 'OWNERSHIP_TYPES_GET_REQUEST',
  OWNERSHIP_TYPES_GET_SUCCESS: 'OWNERSHIP_TYPES_GET_SUCCESS',
  OWNERSHIP_TYPES_GET_ERROR: 'OWNERSHIP_TYPES_GET_ERROR',

  CONTRACT_BLOCKS_GET_REQUEST: 'CONTRACT_BLOCKS_GET_REQUEST',
  CONTRACT_BLOCKS_GET_ERROR: 'CONTRACT_BLOCKS_GET_ERROR',
  CONTRACT_BLOCKS_GET_SUCCESS: 'CONTRACT_BLOCKS_GET_SUCCESS',
  CONTRACT_BLOCKS_UPDATE_CONTENT: 'CONTRACT_BLOCKS_UPDATE_CONTENT',
  CONTRACT_BLOCKS_RESET_CONTENTS: 'CONTRACT_BLOCKS_RESET_CONTENTS',

  WORK_TYPES_GET_REQUEST: 'WORK_TYPES_GET_REQUEST',
  WORK_TYPES_GET_SUCCESS: 'WORK_TYPES_GET_SUCCESS',
  WORK_TYPES_GET_ERROR: 'WORK_TYPES_GET_ERROR',
  SUBWORK_TYPES_GET_REQUEST: 'SUBWORK_TYPES_GET_REQUEST',
  SUBWORK_TYPES_GET_SUCCESS: 'SUBWORK_TYPES_GET_SUCCESS',
  SUBWORK_TYPES_GET_ERROR: 'SUBWORK_TYPES_GET_ERROR',

  /* auth */
  INVALID_TOKEN: 'INVALID_TOKEN',
  SET_LOGGED_IN: 'SET_LOGGED_IN',
  AUTH_LOGIN_REQUEST: 'AUTH_LOGIN_REQUEST',
  AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
  AUTH_LOGIN_ERROR: 'AUTH_LOGIN_ERROR',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
  AUTH_SIGNUP_REQUEST: 'AUTH_SIGNUP_REQUEST',
  AUTH_SIGNUP_SUCCESS: 'AUTH_SIGNUP_SUCCESS',
  AUTH_SIGNUP_ERROR: 'AUTH_SIGNUP_ERROR',
  AUTH_FORGOT_REQUEST: 'AUTH_FORGOT_REQUEST',
  AUTH_FORGOT_SUCCESS: 'AUTH_FORGOT_SUCCESS',
  AUTH_FORGOT_ERROR: 'AUTH_FORGOT_ERROR',
  AUTH_EMAIL_REQUEST: 'AUTH_EMAIL_REQUEST',
  AUTH_EMAIL_SUCCESS: 'AUTH_EMAIL_SUCCESS',
  AUTH_EMAIL_ERROR: 'AUTH_EMAIL_ERROR',
  AUTH_RESET_REQUEST: 'AUTH_RESET_REQUEST',
  AUTH_RESET_SUCCESS: 'AUTH_RESET_SUCCESS',
  AUTH_RESET_ERROR: 'AUTH_RESET_ERROR',
  AUTH_CONFIRM_EMAIL_REQUEST: 'AUTH_CONFIRM_EMAIL_REQUEST',
  AUTH_CONFIRM_EMAIL_SUCCESS: 'AUTH_CONFIRM_EMAIL_SUCCESS',
  AUTH_CONFIRM_EMAIL_ERROR: 'AUTH_CONFIRM_EMAIL_ERROR',
  AUTH_VERIFY_EMAIL_REQUEST: 'AUTH_VERIFY_EMAIL_REQUEST',
  AUTH_VERIFY_EMAIL_SUCCESS: 'AUTH_VERIFY_EMAIL_SUCCESS',
  AUTH_VERIFY_EMAIL_ERROR: 'AUTH_VERIFY_EMAIL_ERROR',
  RESEND_CONFIRMATION_LINK_REQUEST: 'RESEND_CONFIRMATION_LINK_REQUEST',
  RESEND_CONFIRMATION_LINK_SUCCESS: 'RESEND_CONFIRMATION_LINK_SUCCESS',
  RESEND_CONFIRMATION_LINK_ERROR: 'RESEND_CONFIRMATION_LINK_ERROR',

  /* user */
  PROFILE_GET_REQUEST: 'PROFILE_GET_REQUEST',
  PROFILE_GET_SUCCESS: 'PROFILE_GET_SUCCESS',
  PROFILE_GET_ERROR: 'PROFILE_GET_ERROR',
  PROFILE_UPDATE_REQUEST: 'PROFILE_UPDATE_REQUEST',
  PROFILE_UPDATE_SUCCESS: 'PROFILE_UPDATE_SUCCESS',
  PROFILE_UPDATE_ERROR: 'PROFILE_UPDATE_ERROR',

  /* create */
  CREATE_RESET_ATTRIBUTE: 'CREATE_RESET_ATTRIBUTE',
  CREATE_MOVE_STEP: 'CREATE_MOVE_STEP',
  CREATE_ASSIGN_ATTRIBUTE: 'CREATE_ASSIGN_ATTRIBUTE',

  /* teams */
  TEAMS_GET_REQUEST: 'TEAMS_GET_REQUEST',
  TEAMS_GET_SUCCESS: 'TEAMS_GET_SUCCESS',
  TEAMS_GET_ERROR: 'TEAMS_GET_ERROR',
  TEAM_GET_REQUEST: 'TEAM_GET_REQUEST',
  TEAM_GET_SUCCESS: 'TEAM_GET_SUCCESS',
  TEAM_GET_ERROR: 'TEAM_GET_ERROR',
  TEAM_SELECT: 'TEAM_SELECT',
  TEAM_CREATE_REQUEST: 'TEAM_CREATE_REQUEST',
  TEAM_CREATE_SUCCESS: 'TEAM_CREATE_SUCCESS',
  TEAM_CREATE_ERROR: 'TEAM_CREATE_ERROR',
  TEAM_UPDATE_REQUEST: 'TEAM_UPDATE_REQUEST',
  TEAM_UPDATE_SUCCESS: 'TEAM_UPDATE_SUCCESS',
  TEAM_UPDATE_ERROR: 'TEAM_UPDATE_ERROR',
  TEAM_DELETE_REQUEST: 'TEAM_DELETE_REQUEST',
  TEAM_DELETE_SUCCESS: 'TEAM_DELETE_SUCCESS',
  TEAM_DELETE_ERROR: 'TEAM_DELETE_ERROR',
  TEAM_ARCHIVE_REQUEST: 'TEAM_ARCHIVE_REQUEST',
  TEAM_ARCHIVE_SUCCESS: 'TEAM_ARCHIVE_SUCCESS',
  TEAM_ARCHIVE_ERROR: 'TEAM_ARCHIVE_ERROR',
  TEAM_RECOVER_REQUEST: 'TEAM_RECOVER_REQUEST',
  TEAM_RECOVER_SUCCESS: 'TEAM_RECOVER_SUCCESS',
  TEAM_RECOVER_ERROR: 'TEAM_RECOVER_ERROR',

  /* members */
  MEMBERS_GET_REQUEST: 'MEMBERS_GET_REQUEST',
  MEMBERS_GET_SUCCESS: 'MEMBERS_GET_SUCCESS',
  MEMBERS_GET_ERROR: 'MEMBERS_GET_ERROR',
  MEMBER_CREATE_REQUEST: 'MEMBER_CREATE_REQUEST',
  MEMBER_CREATE_SUCCESS: 'MEMBER_CREATE_SUCCESS',
  MEMBER_CREATE_ERROR: 'MEMBER_CREATE_ERROR',
  MEMBER_UPDATE_REQUEST: 'MEMBER_UPDATE_REQUEST',
  MEMBER_UPDATE_SUCCESS: 'MEMBER_UPDATE_SUCCESS',
  MEMBER_UPDATE_ERROR: 'MEMBER_UPDATE_ERROR',
  MEMBER_DELETE_REQUEST: 'MEMBER_DELETE_REQUEST',
  MEMBER_DELETE_SUCCESS: 'MEMBER_DELETE_SUCCESS',
  MEMBER_DELETE_ERROR: 'MEMBER_DELETE_ERROR',
  MEMBERS_SET: 'MEMBERS_SET',
  MEMBER_ADD: 'MEMBER_ADD',
  MEMBER_SAVE: 'MEMBER_SAVE',
  MEMBER_REMOVE: 'MEMBER_REMOVE',

  /* user */
  USERS_GET_REQUEST: 'USERS_GET_REQUEST',
  USERS_GET_ERROR: 'USERS_GET_ERROR',
  USER_GET_REQUEST: 'USER_GET_REQUEST',
  USER_GET_ERROR: 'USER_GET_ERROR',
  USER_GET_SUCCESS: 'USER_GET_SUCCESS',
  USER_UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
  USER_UPDATE_ERROR: 'USER_UPDATE_ERROR',
  USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',

  /* ownership */
  OWNERSHIP_CREATE_REQUEST: 'OWNERSHIP_CREATE_REQUEST',
  OWNERSHIP_CREATE_ERROR: 'OWNERSHIP_CREATE_ERROR',
  OWNERSHIP_CREATE_SUCCESS: 'OWNERSHIP_CREATE_SUCCESS',
  OWNERSHIP_UPDATE_REQUEST: 'OWNERSHIP_UPDATE_REQUEST',
  OWNERSHIP_UPDATE_ERROR: 'OWNERSHIP_UPDATE_ERROR',
  OWNERSHIP_UPDATE_SUCCESS: 'OWNERSHIP_UPDATE_SUCCESS',
  OWNERSHIP_DELETE_REQUEST: 'OWNERSHIP_DELETE_REQUEST',
  OWNERSHIP_DELETE_ERROR: 'OWNERSHIP_DELETE_ERROR',
  OWNERSHIP_DELETE_SUCCESS: 'OWNERSHIP_DELETE_SUCCESS',

  /* agreements */
  AGREEMENTS_GET_REQUEST: 'AGREEMENTS_GET_REQUEST',
  AGREEMENTS_GET_SUCCESS: 'AGREEMENTS_GET_SUCCESS',
  AGREEMENTS_GET_ERROR: 'AGREEMENTS_GET_ERROR',
  AGREEMENT_GET_REQUEST: 'AGREEMENT_GET_REQUEST',
  AGREEMENT_GET_SUCCESS: 'AGREEMENT_GET_SUCCESS',
  AGREEMENT_GET_ERROR: 'AGREEMENT_GET_ERROR',
  AGREEMENT_SELECT: 'AGREEMENT_SELECT',
  AGREEMENT_CREATE_REQUEST: 'AGREEMENT_CREATE_REQUEST',
  AGREEMENT_CREATE_SUCCESS: 'AGREEMENT_CREATE_SUCCESS',
  AGREEMENT_CREATE_ERROR: 'AGREEMENT_CREATE_ERROR',
  AGREEMENT_UPDATE_REQUEST: 'AGREEMENT_UPDATE_REQUEST',
  AGREEMENT_UPDATE_SUCCESS: 'AGREEMENT_UPDATE_SUCCESS',
  AGREEMENT_UPDATE_ERROR: 'AGREEMENT_UPDATE_ERROR',
  AGREEMENT_DELETE_REQUEST: 'AGREEMENT_DELETE_REQUEST',
  AGREEMENT_DELETE_SUCCESS: 'AGREEMENT_DELETE_SUCCESS',
  AGREEMENT_DELETE_ERROR: 'AGREEMENT_DELETE_ERROR',

  AGREEMENT_CONTRACT_BLOCKS_GET_REQUEST:
    'AGREEMENT_CONTRACT_BLOCKS_GET_REQUEST',
  AGREEMENT_CONTRACT_BLOCKS_GET_ERROR: 'AGREEMENT_CONTRACT_BLOCKS_GET_ERROR',
  AGREEMENT_CONTRACT_BLOCKS_GET_SUCCESS:
    'AGREEMENT_CONTRACT_BLOCKS_GET_SUCCESS',
  AGREEMENT_CONTRACT_BLOCKS_SAVE: 'AGREEMENT_CONTRACT_BLOCKS_SAVE',
  AGREEMENT_CONTRACT_BLOCK_SAVE_REQUEST:
    'AGREEMENT_CONTRACT_BLOCK_SAVE_REQUEST',
  AGREEMENT_CONTRACT_BLOCK_SAVE_ERROR: 'AGREEMENT_CONTRACT_BLOCK_SAVE_ERROR',
  AGREEMENT_CONTRACT_BLOCK_SAVE_SUCCESS:
    'AGREEMENT_CONTRACT_BLOCK_SAVE_SUCCESS',

  AGREEMENT_SENTENCE_CREATE_REQUEST: 'AGREEMENT_SENTENCE_CREATE_REQUEST',
  AGREEMENT_SENTENCE_CREATE_SUCCESS: 'AGREEMENT_SENTENCE_CREATE_SUCCESS',
  AGREEMENT_SENTENCE_CREATE_ERROR: 'AGREEMENT_SENTENCE_CREATE_ERROR',
  AGREEMENT_SENTENCE_UPDATE_REQUEST: 'AGREEMENT_SENTENCE_UPDATE_REQUEST',
  AGREEMENT_SENTENCE_UPDATE_SUCCESS: 'AGREEMENT_SENTENCE_UPDATE_SUCCESS',
  AGREEMENT_SENTENCE_UPDATE_ERROR: 'AGREEMENT_SENTENCE_UPDATE_ERROR',
  AGREEMENT_CHANGE_CART: 'AGREEMENT_CHANGE_CART',

  /* works */
  USER_WORKS_GET_REQUEST: 'USER_WORKS_GET_REQUEST',
  USER_WORKS_GET_SUCCESS: 'USER_WORKS_GET_SUCCESS',
  USER_WORKS_GET_ERROR: 'USER_WORKS_GET_ERROR',
  WORK_GET_REQUEST: 'WORK_GET_REQUEST',
  WORK_GET_SUCCESS: 'WORK_GET_SUCCESS',
  WORK_GET_ERROR: 'WORK_GET_ERROR',
  WORK_SELECT: 'WORK_SELECT',
  WORK_CREATE_REQUEST: 'WORK_CREATE_REQUEST',
  WORK_CREATE_SUCCESS: 'WORK_CREATE_SUCCESS',
  WORK_CREATE_ERROR: 'WORK_CREATE_ERROR',
  WORK_UPDATE_REQUEST: 'WORK_UPDATE_REQUEST',
  WORK_UPDATE_SUCCESS: 'WORK_UPDATE_SUCCESS',
  WORK_UPDATE_ERROR: 'WORK_UPDATE_ERROR',
  WORK_DELETE_REQUEST: 'WORK_DELETE_REQUEST',
  WORK_DELETE_SUCCESS: 'WORK_DELETE_SUCCESS',
  WORK_DELETE_ERROR: 'WORK_DELETE_ERROR',

  /* work ownerships */
  WORK_OWNERSHIPS_GET_REQUEST: 'WORK_OWNERSHIPS_GET_REQUEST',
  WORK_OWNERSHIPS_GET_SUCCESS: 'WORK_OWNERSHIPS_GET_SUCCESS',
  WORK_OWNERSHIPS_GET_ERROR: 'WORK_OWNERSHIPS_GET_ERROR',
  WORK_OWNERSHIPS_SET: 'WORK_OWNERSHIPS_SET',
  WORK_OWNERSHIP_GET_REQUEST: 'WORK_OWNERSHIP_GET_REQUEST',
  WORK_OWNERSHIP_GET_SUCCESS: 'WORK_OWNERSHIP_GET_SUCCESS',
  WORK_OWNERSHIP_GET_ERROR: 'WORK_OWNERSHIP_GET_ERROR',
  WORK_OWNERSHIP_CREATE_REQUEST: 'WORK_OWNERSHIP_CREATE_REQUEST',
  WORK_OWNERSHIP_CREATE_SUCCESS: 'WORK_OWNERSHIP_CREATE_SUCCESS',
  WORK_OWNERSHIP_CREATE_ERROR: 'WORK_OWNERSHIP_CREATE_ERROR',
  WORK_OWNERSHIP_UPDATE_REQUEST: 'WORK_OWNERSHIP_UPDATE_REQUEST',
  WORK_OWNERSHIP_UPDATE_SUCCESS: 'WORK_OWNERSHIP_UPDATE_SUCCESS',
  WORK_OWNERSHIP_UPDATE_ERROR: 'WORK_OWNERSHIP_UPDATE_ERROR',
  WORK_OWNERSHIP_DELETE_REQUEST: 'WORK_OWNERSHIP_DELETE_REQUEST',
  WORK_OWNERSHIP_DELETE_SUCCESS: 'WORK_OWNERSHIP_DELETE_SUCCESS',
  WORK_OWNERSHIP_DELETE_ERROR: 'WORK_OWNERSHIP_DELETE_ERROR',

  /* deals */
  DEALS_GET_REQUEST: 'DEALS_GET_REQUEST',
  DEALS_GET_SUCCESS: 'DEALS_GET_SUCCESS',
  DEALS_GET_ERROR: 'DEALS_GET_ERROR',
  DEAL_GET_REQUEST: 'DEAL_GET_REQUEST',
  DEAL_GET_SUCCESS: 'DEAL_GET_SUCCESS',
  DEAL_GET_ERROR: 'DEAL_GET_ERROR',
  DEAL_SELECT: 'DEAL_SELECT',
  DEAL_CREATE_REQUEST: 'DEAL_CREATE_REQUEST',
  DEAL_CREATE_SUCCESS: 'DEAL_CREATE_SUCCESS',
  DEAL_CREATE_ERROR: 'DEAL_CREATE_ERROR',
  DEAL_UPDATE_REQUEST: 'DEAL_UPDATE_REQUEST',
  DEAL_UPDATE_SUCCESS: 'DEAL_UPDATE_SUCCESS',
  DEAL_UPDATE_ERROR: 'DEAL_UPDATE_ERROR',
  DEAL_DELETE_REQUEST: 'DEAL_DELETE_REQUEST',
  DEAL_DELETE_SUCCESS: 'DEAL_DELETE_SUCCESS',
  DEAL_DELETE_ERROR: 'DEAL_DELETE_ERROR',
  DEALS_USER_GET_REQUEST: 'DEALS_USER_GET_REQUEST',
  DEALS_USER_GET_SUCCESS: 'DEALS_USER_GET_SUCCESS',
  DEALS_USER_GET_ERROR: 'DEALS_USER_GET_ERROR',
  FINALIZED_DEALS_GET_REQUEST: 'FINALIZED_DEALS_GET_REQUEST',
  FINALIZED_DEALS_GET_SUCCESS: 'FINALIZED_DEALS_GET_SUCCESS',
  FINALIZED_DEALS_GET_ERROR: 'FINALIZED_DEALS_GET_ERROR',

  INVITES_GET_REQUEST: 'INVITES_GET_REQUEST',
  INVITES_GET_SUCCESS: 'INVITES_GET_SUCCESS',
  INVITES_GET_ERROR: 'INVITES_GET_ERROR',
  INVITE_GET_REQUEST: 'INVITE_GET_REQUEST',
  INVITE_GET_SUCCESS: 'INVITE_GET_SUCCESS',
  INVITE_GET_ERROR: 'INVITE_GET_ERROR',
  INVITE_SELECT: 'INVITE_SELECT',
  INVITE_CREATE_REQUEST: 'INVITE_CREATE_REQUEST',
  INVITE_CREATE_SUCCESS: 'INVITE_CREATE_SUCCESS',
  INVITE_CREATE_ERROR: 'INVITE_CREATE_ERROR',
  INVITE_UPDATE_REQUEST: 'INVITE_UPDATE_REQUEST',
  INVITE_UPDATE_SUCCESS: 'INVITE_UPDATE_SUCCESS',
  INVITE_UPDATE_ERROR: 'INVITE_UPDATE_ERROR',
  INVITE_DELETE_REQUEST: 'INVITE_DELETE_REQUEST',
  INVITE_DELETE_SUCCESS: 'INVITE_DELETE_SUCCESS',
  INVITE_DELETE_ERROR: 'INVITE_DELETE_ERROR',
  INVITE_GET_BY_KEY_REQUEST: 'INVITE_GET_BY_KEY_REQUEST',
  INVITE_GET_BY_KEY_ERROR: 'INVITE_GET_BY_KEY_ERROR',
  INVITE_GET_BY_KEY_SUCCESS: 'INVITE_GET_BY_KEY_SUCCESS',
  INVITES_USER_GET_REQUEST: 'INVITES_USER_GET_REQUEST',
  INVITES_USER_GET_SUCCESS: 'INVITES_USER_GET_SUCCESS',
  INVITES_USER_GET_ERROR: 'INVITES_USER_GET_ERROR',
  RESEND_DEAL_INVITATION_REQUEST: 'RESEND_DEAL_INVITATION_REQUEST',
  RESEND_DEAL_INVITATION_SUCCESS: 'RESEND_DEAL_INVITATION_SUCCESS',
  RESEND_DEAL_INVITATION_ERROR: 'RESEND_DEAL_INVITATION_ERROR',

  /* deal blocks */
  DEAL_BLOCK_SET_CHANGES: 'DEAL_BLOCK_SET_CHANGES',
  DEAL_BLOCK_REMOVE_CHANGES: 'DEAL_BLOCK_REMOVE_CHANGES',
  DEAL_BLOCK_RESET_CHANGES: 'DEAL_BLOCK_RESET_CHANGES',

  /* deal changes */
  DEAL_CHANGES_GET_REQUEST: 'DEAL_CHANGES_GET_REQUEST',
  DEAL_CHANGES_GET_SUCCESS: 'DEAL_CHANGES_GET_SUCCESS',
  DEAL_CHANGES_GET_ERROR: 'DEAL_CHANGES_GET_ERROR',
  DEAL_CHANGE_GET_REQUEST: 'DEAL_CHANGE_GET_REQUEST',
  DEAL_CHANGE_GET_SUCCESS: 'DEAL_CHANGE_GET_SUCCESS',
  DEAL_CHANGE_GET_ERROR: 'DEAL_CHANGE_GET_ERROR',
  DEAL_CHANGE_CREATE_REQUEST: 'DEAL_CHANGE_CREATE_REQUEST',
  DEAL_CHANGE_CREATE_SUCCESS: 'DEAL_CHANGE_CREATE_SUCCESS',
  DEAL_CHANGE_CREATE_ERROR: 'DEAL_CHANGE_CREATE_ERROR',
  DEAL_CHANGE_DELETE_REQUEST: 'DEAL_CHANGE_DELETE_REQUEST',
  DEAL_CHANGE_DELETE_SUCCESS: 'DEAL_CHANGE_DELETE_SUCCESS',
  DEAL_CHANGE_DELETE_ERROR: 'DEAL_CHANGE_DELETE_ERROR',
  DEAL_CHANGE_UPDATE_REQUEST: 'DEAL_CHANGE_UPDATE_REQUEST',
  DEAL_CHANGE_UPDATE_SUCCESS: 'DEAL_CHANGE_UPDATE_SUCCESS',
  DEAL_CHANGE_UPDATE_ERROR: 'DEAL_CHANGE_UPDATE_ERROR',
  DEAL_CHANGE_NOTIFY_REQUEST: 'DEAL_CHANGE_NOTIFY_REQUEST',
  DEAL_INVITEE_CHANGE_EMAIL_REQUEST: 'DEAL_INVITEE_CHANGE_EMAIL_REQUEST',

  /* deal messages */
  DEAL_MESSAGES_GET_REQUEST: 'DEAL_MESSAGES_GET_REQUEST',
  DEAL_MESSAGES_GET_SUCCESS: 'DEAL_MESSAGES_GET_SUCCESS',
  DEAL_MESSAGES_GET_ERROR: 'DEAL_MESSAGES_GET_ERROR',
  DEAL_MESSAGE_SEND_REQUEST: 'DEAL_MESSAGE_SEND_REQUEST',
  DEAL_MESSAGE_SEND_SUCCESS: 'DEAL_MESSAGE_SEND_SUCCESS',
  DEAL_MESSAGE_SEND_ERROR: 'DEAL_MESSAGE_SEND_ERROR',
  DEAL_MESSAGE_UPDATE_REQUEST: 'DEAL_MESSAGE_UPDATE_REQUEST',
  DEAL_MESSAGE_UPDATE_SUCCESS: 'DEAL_MESSAGE_UPDATE_SUCCESS',
  DEAL_MESSAGE_UPDATE_ERROR: 'DEAL_MESSAGE_UPDATE_ERROR',
  DEAL_MESSAGE_DELETE_REQUEST: 'DEAL_MESSAGE_DELETE_REQUEST',
  DEAL_MESSAGE_DELETE_SUCCESS: 'DEAL_MESSAGE_DELETE_SUCCESS',
  DEAL_MESSAGE_DELETE_ERROR: 'DEAL_MESSAGE_DELETE_ERROR',

  /* deal users */
  DEAL_USERS_GET_REQUEST: 'DEAL_USERS_GET_REQUEST',
  DEAL_USERS_GET_SUCCESS: 'DEAL_USERS_GET_SUCCESS',
  DEAL_USERS_GET_ERROR: 'DEAL_USERS_GET_ERROR',
  DEAL_USER_GET_REQUEST: 'DEAL_USER_GET_REQUEST',
  DEAL_USER_GET_SUCCESS: 'DEAL_USER_GET_SUCCESS',
  DEAL_USER_GET_ERROR: 'DEAL_USER_GET_ERROR',
  DEAL_USER_SELECT: 'DEAL_USER_SELECT',
  DEAL_USER_CREATE_REQUEST: 'DEAL_USER_CREATE_REQUEST',
  DEAL_USER_CREATE_SUCCESS: 'DEAL_USER_CREATE_SUCCESS',
  DEAL_USER_CREATE_ERROR: 'DEAL_USER_CREATE_ERROR',
  DEAL_USER_UPDATE_REQUEST: 'DEAL_USER_UPDATE_REQUEST',
  DEAL_USER_UPDATE_SUCCESS: 'DEAL_USER_UPDATE_SUCCESS',
  DEAL_USER_UPDATE_ERROR: 'DEAL_USER_UPDATE_ERROR',
  DEAL_USER_DELETE_REQUEST: 'DEAL_USER_DELETE_REQUEST',
  DEAL_USER_DELETE_SUCCESS: 'DEAL_USER_DELETE_SUCCESS',
  DEAL_USER_DELETE_ERROR: 'DEAL_USER_DELETE_ERROR',

  /* copyright registration */
  COREG_RESET_ATTRIBUTE: 'COREG_RESET_ATTRIBUTE',
  COREG_ASSIGN_ATTRIBUTE: 'COREG_ASSIGN_ATTRIBUTE',
  COREG_CREATE_REQUEST: 'COREG_CREATE_REQUEST',
  COREG_CREATE_SUCCESS: 'COREG_CREATE_SUCCESS',
  COREG_CREATE_ERROR: 'COREG_CREATE_ERROR',
  COREG_UPDATE_REQUEST: 'COREG_UPDATE_REQUEST',
  COREG_UPDATE_SUCCESS: 'COREG_UPDATE_SUCCESS',
  COREG_UPDATE_ERROR: 'COREG_UPDATE_ERROR',
  COREG_FILE_CREATE_REQUEST: 'COREG_FILE_CREATE_REQUEST',
  COREG_FILE_CREATE_SUCCESS: 'COREG_FILE_CREATE_SUCCESS',
  COREG_FILE_CREATE_ERROR: 'COREG_FILE_CREATE_ERROR',
  COREG_CHANGE_CART: 'COREG_CHANGE_CART',
  COREG_TEMP_CREATE_REQUEST: 'COREG_TEMP_CREATE_REQUEST',
  COREG_TEMP_CREATE_SUCCESS: 'COREG_TEMP_CREATE_SUCCESS',
  COREG_TEMP_CREATE_ERROR: 'COREG_TEMP_CREATE_ERROR',

  /* payment */
  PAYMENT_CLIENT_TOKEN_REQUEST: 'PAYMENT_CLIENT_TOKEN_REQUEST',
  PAYMENT_CLIENT_TOKEN_SUCCESS: 'PAYMENT_CLIENT_TOKEN_SUCCESS',
  PAYMENT_CLIENT_TOKEN_ERROR: 'PAYMENT_CLIENT_TOKEN_ERROR',
  PAYMENT_CHECKOUT_REQUEST: 'PAYMENT_CHECKOUT_REQUEST',
  PAYMENT_CHECKOUT_SUCCESS: 'PAYMENT_CHECKOUT_SUCCESS',
  PAYMENT_CHECKOUT_ERROR: 'PAYMENT_CHECKOUT_ERROR',
  PAYMENT_GET_CUSTOMER_REQUEST: 'PAYMENT_GET_CUSTOMER_REQUEST',
  PAYMENT_GET_CUSTOMER_SUCCESS: 'PAYMENT_GET_CUSTOMER_SUCCESS',
  PAYMENT_GET_CUSTOMER_ERROR: 'PAYMENT_GET_CUSTOMER_ERROR',
  PAYMENT_GET_SUBSCRIBE_REQUEST: 'PAYMENT_GET_SUBSCRIBE_REQUEST',
  PAYMENT_GET_SUBSCRIBE_SUCCESS: 'PAYMENT_GET_SUBSCRIBE_SUCCESS',
  PAYMENT_GET_SUBSCRIBE_ERROR: 'PAYMENT_GET_SUBSCRIBE_ERROR',
  PAYMENT_SUBSCRIBE_REQUEST: 'PAYMENT_SUBSCRIBE_REQUEST',
  PAYMENT_SUBSCRIBE_SUCCESS: 'PAYMENT_SUBSCRIBE_SUCCESS',
  PAYMENT_SUBSCRIBE_ERROR: 'PAYMENT_SUBSCRIBE_ERROR',
  PAYMENT_CANCEL_SUBSCRIBE_REQUEST: 'PAYMENT_CANCEL_SUBSCRIBE_REQUEST',
  PAYMENT_CANCEL_SUBSCRIBE_SUCCESS: 'PAYMENT_CANCEL_SUBSCRIBE_SUCCESS',
  PAYMENT_CANCEL_SUBSCRIBE_ERROR: 'PAYMENT_CANCEL_SUBSCRIBE_ERROR',
  PAYMENT_TRANSACTION_REQUEST: 'PAYMENT_TRANSACTION_REQUEST',
  PAYMENT_TRANSACTION_SUCCESS: 'PAYMENT_TRANSACTION_SUCCESS',
  PAYMENT_TRANSACTION_ERROR: 'PAYMENT_TRANSACTION_ERROR',

  /* phone verify */
  PHONE_VERIFY_REQUEST: 'PHONE_VERIFY_REQUEST',
  PHONE_VERIFY_SUCCESS: 'PHONE_VERIFY_SUCCESS',
  PHONE_VERIFY_ERROR: 'PHONE_VERIFY_ERROR',
  PHONE_VERIFY_CHECK_REQUEST: 'PHONE_VERIFY_CHECK_REQUEST',
  PHONE_VERIFY_CHECK_SUCCESS: 'PHONE_VERIFY_CHECK_SUCCESS',
  PHONE_VERIFY_CHECK_ERROR: 'PHONE_VERIFY_CHECK_ERROR',

  /* password change */
  PASSWORD_CHANGE_REQUEST: 'PASSWORD_CHANGE_REQUEST',
  PASSWORD_CHANGE_SUCCESS: 'PASSWORD_CHANGE_SUCCESS',
  PASSWORD_CHANGE_ERROR: 'PASSWORD_CHANGE_ERROR',

  PUBLISHERS_GET_REQUEST: 'PUBLISHERS_GET_REQUEST',
  PUBLISHERS_GET_SUCCESS: 'PUBLISHERS_GET_SUCCESS',
  PUBLISHERS_GET_ERROR: 'PUBLISHERS_GET_ERROR',
  PUBLISHER_CREATE_REQUEST: 'PUBLISHER_CREATE_REQUEST',
  PUBLISHER_CREATE_SUCCESS: 'PUBLISHER_CREATE_SUCCESS',
  PUBLISHER_CREATE_ERROR: 'PUBLISHER_CREATE_ERROR',
  PUBLISHER_UPDATE_REQUEST: 'PUBLISHER_UPDATE_REQUEST',
  PUBLISHER_UPDATE_SUCCESS: 'PUBLISHER_UPDATE_SUCCESS',
  PUBLISHER_UPDATE_ERROR: 'PUBLISHER_UPDATE_ERROR',
  PUBLISHER_DELETE_REQUEST: 'PUBLISHER_DELETE_REQUEST',
  PUBLISHER_DELETE_SUCCESS: 'PUBLISHER_DELETE_SUCCESS',

  /* User marketing */
  GET_MARKETING_CONTENT_REQUEST: 'GET_MARKETING_CONTENT_REQUEST',
  GET_MARKETING_CONTENT_SUCCESS: 'GET_MARKETING_CONTENT_SUCCESS',
  GET_MARKETING_CONTENT_ERROR: 'GET_MARKETING_CONTENT_ERROR',
  CREATE_MARKETING_CONTENT_REQUEST: 'CREATE_MARKETING_CONTENT_REQUEST',
  CREATE_MARKETING_CONTENT_SUCCESS: 'CREATE_MARKETING_CONTENT_SUCCESS',
  CREATE_MARKETING_CONTENT_ERROR: 'CREATE_MARKETING_CONTENT_ERROR',
  UPDATE_MARKETING_CONTENT_REQUEST: 'UPDATE_MARKETING_CONTENT_REQUEST',
  UPDATE_MARKETING_CONTENT_SUCCESS: 'UPDATE_MARKETING_CONTENT_SUCCESS',
  UPDATE_MARKETING_CONTENT_ERROR: 'UPDATE_MARKETING_CONTENT_ERROR',
  FIX_AGREEMENT_INVITE_ISSUE_REQUEST: 'FIX_AGREEMENT_INVITE_ISSUE_REQUEST',
  FIX_AGREEMENT_INVITE_ISSUE_SUCCESS: 'FIX_AGREEMENT_INVITE_ISSUE_SUCCESS',
  FIX_AGREEMENT_INVITE_ISSUE_ERROR: 'FIX_AGREEMENT_INVITE_ISSUE_ERROR',
};



// WEBPACK FOOTER //
// src/redux/actionTypes.js